
import * as storyblokRuntime$Tsg2oM75yX from '/builds/common/airbaltic-com/company/node_modules/@nuxt/image/dist/runtime/providers/storyblok'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "storyblok",
  "domains": [
    "a.storyblok.com",
    "assets.airbaltic.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$Tsg2oM75yX, defaults: {"baseURL":"https://assets.airbaltic.com"} }
}
        